import mine from "./mine";
import news from "./news";
import studyTask from "./studyTask";
import collectionCourse from "./collectionCourse";
import learningStatistics from "./learningStatistics";
export default [studyTask, news, mine, collectionCourse, learningStatistics];
